export const IconCloud = ({ size = 16, color = 'black' }: { size?: number; color?: string }) => {
  return (
    <svg fill="none" height={size} viewBox="0 0 16 16" width={size} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_388_4501)">
        <path
          d="M8.81286 6.65332L8.73037 9.28385C8.73037 9.91017 8.5654 10.5365 8.2767 11.0793C7.988 11.6221 7.53432 12.0814 6.99816 12.4154C6.46201 12.7495 5.8846 12.9582 5.26596 13H4.89477C3.94619 13 4.97726 13 3.98743 13C3.53376 13 3.08008 12.9582 2.62641 12.7912C1.63658 12.4154 0.935448 11.7056 0.729233 10.6618C0.564262 9.86842 0.729233 9.11684 1.14166 8.44877C1.51285 7.8642 2.00777 7.44666 2.66765 7.23789C2.75014 7.23789 2.75014 7.19613 2.75014 7.11262C2.83263 6.36104 3.12133 5.73473 3.69873 5.23367C4.19364 4.81613 4.77104 4.64911 5.43093 4.69087C5.63715 4.69087 5.84336 4.77437 6.04958 4.81613C6.13206 4.81613 6.13206 4.81613 6.17331 4.77437C6.50325 4.23157 6.95692 3.81402 7.49308 3.47999C7.90551 3.22946 8.35918 3.1042 8.8541 3.02069C9.7202 2.93718 10.5863 3.1042 11.3287 3.5635C12.401 4.27332 12.9784 5.27543 13.1021 6.56982C13.1021 6.65332 13.1434 6.65332 13.1846 6.65332C13.9682 6.94561 14.5456 7.44666 14.9168 8.15648C15.3705 8.99157 15.453 9.82666 15.1643 10.7035C14.8343 11.7474 14.092 12.4572 13.0609 12.833C12.7309 12.9582 12.3598 13 11.9886 13C11.1225 13 10.2564 13 9.4315 13"
          stroke={color}
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path d="M10.9996 8.53372L8.79961 6.40039L6.59961 8.53372" stroke={color} strokeWidth="1.5" />
      </g>
      <defs>
        <clipPath id="clip0_388_4501">
          <rect fill="white" height="16" width="16" />
        </clipPath>
      </defs>
    </svg>
  );
};
